import { useState, useEffect } from "react";
import { Modal, List, Tooltip, Button } from 'antd';
import axios from "axios";
import { PdfContent } from "./styled";
import { toast } from "react-toastify";
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import CircularProgress from '@mui/material/CircularProgress';
import { ProgressExport } from "../../../../../../styledEvents";

import "./style.css"
import { Method_POST_REST } from "../../../../../../service/api";

export function ModalEmitidasArquivo({ isOpen, onClose, idFile }) {
    const [isLoading, setLoading] = useState(false);
    const [isLoadingCicle] = useState(false);
    const [pdfData, setPdfData] = useState(null);
    const [isIdFile, setIsIdFile] = useState(idFile);
    const [exporting, setExporting] = useState(false);

    useEffect(() => {
        let height = 1000;
        window.parent.postMessage({ frameHeight: height, scrollUp: true }, "*");
    });

    useEffect(() => {
        if (isOpen && idFile) {
            arquivoListar(idFile);
            setIsIdFile(idFile);
        }
    }, [isOpen, idFile]);

    const arquivoListar = async (idFile) => {
        const url = "/contador/obrigacao/arquivo/listar";
        const data = {
            id: idFile,
        };

        setLoading(true);
        try {
            const response = await Method_POST_REST(url, data);
            //console.log("Debug:", response);
            setPdfData(response);

        } catch (error) {
            toast.error("dados do arquivo não encontrados", error);
        } finally {
            setLoading(false);
        }
    }

    const handleView = async (index) => {
        const documento = pdfData.files[index];
        var fileName = documento.split('\\').pop().split('/').pop();

        const url = `/portal/rest/contador/obrigacao/arquivo/view?id=${isIdFile}&filename=${fileName}`;

        setExporting(true);
        try {
            window.open(url, '_blank');

        } catch (error) {
            toast.error("Não foi possível visualizar o arquivo", error);
            setExporting(false);
        } finally {
            setExporting(false);
        }
    }

    const handleDownload = async (index) => {
        const documento = pdfData.files[index];
        console.log(documento);
        var fileName = documento.split('\\').pop().split('/').pop();


        const url = `/portal/rest/contador/obrigacao/arquivo/download?id=${isIdFile}&filename=${fileName}`;

        setExporting(true);
        try {
            const response = await axios.get(`/portal/rest/contador/obrigacao/arquivo/download?id=${isIdFile}&filename=${fileName}`, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Erro ao baixar arquivo:', error);
            toast.error('Erro ao baixar arquivo.');
        } finally {
            setExporting(false);
        }
    };

    return (
        <Modal
            title="Arquivos de Guias de Impostos"
            open={isOpen}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>
                    Fechar
                </Button>,
            ]}
        >
            {pdfData && (
                <div>
                    <p><strong>Nome do Arquivo:</strong> {pdfData.nome}</p>
                    <p><strong>Descrição:</strong> {pdfData.descricao}</p>
                    <p><strong>Data de Emissão:</strong> {new Date(pdfData.dataEmissao).toLocaleDateString()}</p>
                    <p><strong>Arquivos:</strong></p>
                    {pdfData.files && pdfData.files.length > 0 ? (
                        <PdfContent>
                            <List
                                dataSource={pdfData.files}
                                renderItem={(item, index) => (
                                    <>
                                        <List.Item>
                                            {exporting ? (
                                                <div className="center-circular-progress">
                                                    <ProgressExport>
                                                        <CircularProgress disableShrink />
                                                    </ProgressExport>
                                                </div>
                                            ) : (

                                                <div className="tabela-container-arq">
                                                    <div className="tabela-header-arq">
                                                        <div className="col-arq">Arquivo</div>
                                                        <div className="col-arq" style={{ display: "flex", textAlign: "center", justifyContent: "center" }}>Ações</div>
                                                    </div>

                                                    <div className="tabela-grid-arq">
                                                        <div className="tabela-card-arq">
                                                            <div className="tabela-card-padrao-arq">
                                                                <div className="tabela-linha-arq">
                                                                    <div className="col-arq">
                                                                        <div style={{ padding: 5 }}>{item.split('\\').pop().split('/').pop()}</div>
                                                                    </div>

                                                                    <div className="col-arq">
                                                                        <div style={{ display: "flex", justifyContent: "center" }}>

                                                                            <Tooltip title="Visualizar">
                                                                                <div onClick={() => handleView(index)} className="btn-arq">
                                                                                    <EyeOutlined />
                                                                                </div>
                                                                            </Tooltip>

                                                                                <Tooltip title="Download">
                                                                                    {isLoadingCicle ? (
                                                                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', top: '-12px' }}>
                                                                                            <CircularProgress />
                                                                                        </Box>
                                                                                    ) : (
                                                                                        <div onClick={() => handleDownload(index)} className="btn-arq">
                                                                                            <DownloadOutlined />
                                                                                        </div>
                                                                                    )}
                                                                                </Tooltip>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            )}
                                        </List.Item>
                                    </>
                                )}
                            />
                        </PdfContent>
                    ) : (
                        <>
                            <p>Nenhum arquivo encontrado.</p>
                        </>
                    )}
                </div>
            )}
            {isLoading && (
                <Box sx={{ width: "100%" }}>
                    <LinearProgress />
                </Box>
            )}
        </Modal>

    );
}

export default ModalEmitidasArquivo;